var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarHollow = function SvgStarHollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28B2D",
    strokeWidth: 1.5,
    d: "m9 2.427 1.307 4.024.169.518h4.775L11.83 9.456l-.441.32.168.518 1.308 4.024L9.44 11.83 9 11.51l-.44.32-3.423 2.487 1.307-4.024.168-.518-.44-.32-3.423-2.487h4.775l.169-.518z"
  })));
};
export default SvgStarHollow;